<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    export default {
        name: 'bundles',
        data () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// Bundles.vue?ac813d0e